// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"3bdbec91","513":"dd46a8f9","703":"c8822ce4","787":"6dbba31b"}[chunkId] + ".chunk.js";
};